import useEcoClient from "../useEcoClient"

export const useRuntimeAuth = () => {
    const ecoClient = useEcoClient()
    return ecoClient.getAuth()
}
